import { render, staticRenderFns } from "./AnnotationTypeIndemnity.vue?vue&type=template&id=426992c4&scoped=true"
import script from "./AnnotationTypeIndemnity.vue?vue&type=script&lang=js"
export * from "./AnnotationTypeIndemnity.vue?vue&type=script&lang=js"
import style0 from "./AnnotationTypeIndemnity.vue?vue&type=style&index=0&id=426992c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426992c4",
  null
  
)

export default component.exports